export const getCart = async (location = window.routes.cart_url) => {
  const response = await fetch(location, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  return await response.json()
}

export const getCartSections = async (sections = 'mini-cart,header') => {
  const response = await fetch(`/?sections=${sections}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

  const data = await response.json();

  return {
    sections: data
  };
};

export const changeCart = async (
  payload,
  sections = 'mini-cart,header',
  location = window.routes.cart_change_url
) => {
  const response = await fetch(location, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      sections,
      ...payload,
    }),
  })
  return await response.json()
}

export const addToCart = async (
  payload,
  sections = 'mini-cart,header',
  location = window.routes.cart_add_url
) => {
  const response = await fetch(location, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      sections,
      ...payload,
    }),
  })
  return await response.json()
}

export const updateCart = async (
  payload,
  sections = 'mini-cart,header',
  location = window.routes.cart_update_url
) => {
  const response = await fetch(location, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      sections,
      ...payload,
    }),
  })
  return await response.json()
}

export const clearCart = async (
  sections = 'mini-cart,header',
  location = window.routes.cart_clear_url
) => {
  const response = await fetch(location, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      sections
    }),
  })
  return await response.json()
}
